module.exports = __webpack_public_path__ + "static/img/pattern.508ce619.svg";